// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg width=%27100%27 height=%27100%27 viewBox=%270 0 100 100%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M11 18c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm48 25c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm-43-7c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm63 31c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM34 90c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm56-76c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM12 86c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm28-65c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm23-11c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-6 60c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm29 22c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zM32 63c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm57-13c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-9-21c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM60 91c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM35 41c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM12 60c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2z%27 fill=%27%239C92AC%27 fill-opacity=%270.08%27 fill-rule=%27evenodd%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Контейнер: Лист бумаги на столе */
.quiz-container {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  width: 90%;
  max-width: 360px;

  /* Эффект бумаги */
  background-color: #f4e4bc;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});

  /* Тени для объема листа */
  box-shadow:
    1px 1px 0 rgba(0,0,0,0.1),
    0 10px 30px rgba(0,0,0,0.5);

  color: #2c2c2c;
  padding: 25px 20px;
  border-radius: 2px;

  /* Эффект старого шрифта */
  font-family: 'Times New Roman', Times, serif;

  z-index: 6000;
  pointer-events: auto;

  /* Небольшой поворот для естественности */
  transform: translate(-50%, -50%) rotate(-1deg);
}

/* Скрепка или штамп в углу */
.quiz-header {
  border-bottom: 2px solid #333;
  margin-bottom: 20px;
  padding-bottom: 10px;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}

.quiz-title {
  font-size: 20px;
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.quiz-progress {
  font-size: 14px;
  font-family: 'Apple Color Emoji', 'Segoe UI Emoji', 'Noto Color Emoji', 'Courier New', monospace;
  font-weight: bold;
}

/* Текст вопроса */
.quiz-question-text {
  font-size: 18px;
  line-height: 1.4;
  margin-bottom: 25px;
  min-height: 60px;
  font-weight: 600;

  /* --- ДОБАВЛЕНО --- */
  white-space: pre-wrap; /* Сохраняет переносы строк \\n */
  text-align: left;   
  font-family: 'Apple Color Emoji', 'Segoe UI Emoji', 'Noto Color Emoji', sans-serif; /* Улучшает отображение эмодзи */
}

/* Варианты ответов */
.quiz-options-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
}

.quiz-btn {
  background: transparent;
  border: 2px solid #555;
  color: #333;
  padding: 12px;
  font-size: 16px;
  font-family: 'Apple Color Emoji', 'Segoe UI Emoji', 'Noto Color Emoji', 'Courier New', monospace;
  font-weight: bold;
  cursor: pointer;
  text-align: left;
  transition: all 0.1s ease;
  position: relative;
  overflow: hidden;
}

.quiz-btn:active {
  background: #333;
  color: #f4e4bc;
  transform: scale(0.98);
}

/* Поле ввода */
.quiz-input-row {
  display: flex;
  gap: 8px;
}

.quiz-input {
  flex: 1 1;
  background: transparent;
  border: 2px solid #333;
  border-radius: 0; /* Прямые углы для стиля */
  padding: 10px;
  font-size: 18px;
  font-family: 'Apple Color Emoji', 'Segoe UI Emoji', 'Noto Color Emoji', 'Courier New', monospace;
  color: #333;
  outline: none;
  min-width: 0;
}

.quiz-input:focus {
  background: rgba(0,0,0,0.05);
  border-color: #000;
}

.quiz-submit-btn {
  background: #333;
  color: #f4e4bc;
  border: none;
  padding: 0 20px;
  font-weight: bold;
  font-size: 20px;
  cursor: pointer;
  flex-shrink: 0;
}

/* --- ШТАМПЫ РЕЗУЛЬТАТА --- */
.quiz-stamp-overlay {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none; /* Пропускаем клики */
  z-index: 10;
}

.stamp {
  font-size: 32px;
  font-weight: 900;
  text-transform: uppercase;

  /* Эффект двойной рамки как у печати */
  border: 6px double;
  padding: 10px 20px;
  border-radius: 8px;

  transform: rotate(-15deg) scale(2); /* Начинаем с большого */
  opacity: 0;
  animation: stampIn 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;

  /* Добавим фон для четкого перекрытия текста */
  background-color: rgba(255, 255, 255, 0.9);
  box-shadow: 0 4px 10px rgba(0,0,0,0.2);

  /* Убрана невалидная маска, которая делала элемент невидимым */
}

.stamp-success {
  color: #27ae60;
  border-color: #27ae60;
  text-shadow: 0 0 0 #27ae60;
}

.stamp-fail {
  color: #c0392b;
  border-color: #c0392b;
}

@keyframes stampIn {
  to { transform: rotate(-15deg) scale(1); opacity: 0.8; }
}

/* Финальный экран */
.quiz-final {
  text-align: center;
}
.final-score {
  font-size: 48px;
  font-weight: bold;
  margin: 20px 0;
  color: #333;
  font-family: 'Apple Color Emoji', 'Segoe UI Emoji', 'Noto Color Emoji', 'Courier New', monospace;
  border: 3px solid #333;
  display: inline-block;
  padding: 10px 20px;
  border-radius: 50%; /* Круглая печать оценки */
  transform: rotate(5deg);
}

/* Таймер */
.quiz-timer {
  position: absolute;
  top: -40px;
  right: 0;
  background: #333;
  color: #f4e4bc;
  padding: 5px 10px;
  border-radius: 4px;
  font-family: monospace;
  font-weight: bold;
  font-size: 16px;
  box-shadow: 0 5px 10px rgba(0,0,0,0.3);
}


/* Состояние: Ожидание ответа сервера (выбрано пользователем) */
.quiz-btn.pending {
  background: #dcd0b0; /* Чуть темнее фона */
  border-color: #333;
  color: #333;
  cursor: wait;
  transform: scale(0.98);
}

/* Состояние: Правильный ответ (подсветка при показе результата) */
.quiz-btn.correct {
  background: #d4edda;
  border-color: #28a745;
  color: #155724;
}

/* Состояние: Неправильный выбор */
.quiz-btn.wrong {
  background: #f8d7da;
  border-color: #dc3545;
  color: #721c24;
}

/* Блокировка остальных кнопок */
.quiz-btn.disabled {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}

/* Поле ввода - состояние загрузки */
.quiz-input-row.pending {
  opacity: 0.7;
  pointer-events: none;
}

.quiz-input.pending {
  background-color: #eec;
}

/* Улучшаем штампы */
.quiz-stamp-overlay {
  background: rgba(244, 228, 188, 0.4); /* Полупрозрачный фон, чтобы приглушить текст вопроса */
  backdrop-filter: blur(1px); /* Легкий блюр для фокуса на штампе */
  border-radius: 4px;
}

.stamp {
  background-color: rgba(255, 255, 255, 0.8); /* Фон для читаемости штампа */
  box-shadow: 0 4px 15px rgba(0,0,0,0.2);
}

/* --- СТИЛИ ДЛЯ ИНПУТА --- */

/* Состояние: Ожидание (отправили, ждем) */
.quiz-input.pending {
  opacity: 0.7;
  background-color: #eee;
}

/* Состояние: ВЕРНО */
.quiz-input.correct {
  background-color: #d4edda !important; /* !important перебивает disabled */
  border-color: #28a745 !important;
  color: #155724 !important;
  opacity: 1 !important;
}

/* Состояние: ОШИБКА */
.quiz-input.incorrect {
  background-color: #f8d7da !important;
  border-color: #dc3545 !important;
  color: #721c24 !important;
  opacity: 1 !important;
}

/* Стилизация тега code внутри вопроса */
.quiz-question-text code,
.quiz-btn code {
  background-color: rgba(0, 0, 0, 0.08); /* Легкий серый фон */
  color: #c7254e; /* Цвет текста (или оставьте inherit) */
  padding: 2px 4px;
  border-radius: 4px;
  font-family: 'Apple Color Emoji', 'Segoe UI Emoji', 'Noto Color Emoji', 'Courier New', monospace; /* Моноширинный шрифт */
  font-size: 0.95em;
  font-weight: bold;
}

/* Опционально: убедитесь, что bold и italic наследуются правильно */
.quiz-question-text b, .quiz-question-text strong {
  font-weight: 800;
}

.quiz-question-text i, .quiz-question-text em {
  font-style: italic;
}

/* --- Стили для результатов ответов --- */

/* Класс для кнопки с правильным ответом (всегда подсвечиваем) */
.quiz-btn.reveal-correct {
  background-color: #d4edda;
  border-color: #28a745;
  color: #155724;
  box-shadow: 0 0 8px rgba(40, 167, 69, 0.4);
}

/* Класс для кнопки, если пользователь выбрал НЕПРАВИЛЬНО */
.quiz-btn.reveal-wrong {
  background-color: #f8d7da;
  border-color: #dc3545;
  color: #721c24;
  text-decoration: line-through; /* Зачеркиваем ошибку */
}

/* --- Кнопка и экран "Анализ ошибок" --- */

.quiz-close-btn {
  background: transparent;
  border: 2px solid #555;
  color: #333;
  padding: 10px;
  font-size: 18px;
  font-weight: 800;
  font-family: 'Apple Color Emoji', 'Segoe UI Emoji', 'Noto Color Emoji', 'Courier New', monospace;
  cursor: pointer;
  text-align: center;
  text-transform: uppercase;
  transition: all 0.1s ease;
  position: relative;
  overflow: hidden;
}

.quiz-history-btn {
  background: #34495e;
  color: #f4e4bc;
  border: 2px solid #2c3e50;
  width: 100%;
  padding: 10px;
  font-size: 18px;
  font-weight: 800;
  font-family: 'Apple Color Emoji', 'Segoe UI Emoji', 'Noto Color Emoji', 'Courier New', monospace;
  cursor: pointer;
  text-align: center;
  margin-top: 10px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  transition: all 0.2s;
}

.quiz-history-btn:active {
  transform: scale(0.98);
}

/* Оверлей истории (стилизован под папку с делом) */
.quiz-history-overlay {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background: #f4e4bc; /* Тот же цвет "бумаги", что и у основного контейнера */
  z-index: 20;
  display: flex;
  flex-direction: column;
  padding: 20px 15px;
  animation: slideUp 0.3s ease-out;
  border-radius: 2px;
}

@keyframes slideUp {
  from { transform: translateY(100%); }
  to { transform: translateY(0); }
}

.history-header-title {
  font-size: 20px;
  font-weight: 900;
  text-align: center;
  color: #2c3e50;
  border-bottom: 2px solid #2c3e50;
  padding-bottom: 10px;
  margin-bottom: 15px;
  text-transform: uppercase;
}

.history-list {
  flex: 1 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-right: 5px;
}

.history-list * {
  touch-action: pan-y;
}

/* Элемент истории (вопрос) */
.history-item {
  background: rgba(255, 255, 255, 0.6);
  padding: 10px;
  border-radius: 6px;
  border-left: 5px solid #ccc;
  text-align: left;
}

.history-item.correct {
  border-left-color: #27ae60;
}

.history-item.wrong {
  border-left-color: #c0392b;
}

/* Текст вопроса в истории (с переносами строк для сетки) */
.history-q-text {
  font-weight: 600;
  margin-bottom: 8px;
  white-space: pre-wrap; /* ВАЖНО: сохраняет структуру сетки */
  font-family: 'Apple Color Emoji', 'Segoe UI Emoji', 'Noto Color Emoji', sans-serif;
  font-size: 14px;
  line-height: 1.3;
  color: #333;
}

.history-answer-row {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  border-top: 1px solid rgba(0,0,0,0.1);
  padding-top: 5px;
  margin-top: 5px;
}

.ans-label { opacity: 0.7; margin-right: 4px; }
.ans-val { font-weight: bold; }
.ans-val.bad { color: #c0392b; }
.ans-val.good { color: #27ae60; }`, "",{"version":3,"sources":["webpack://./src/components/arcade/games/quiz/DetectiveQuiz.css"],"names":[],"mappings":"AAAA,oCAAoC;AACpC;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;;EAEhC,UAAU;EACV,gBAAgB;;EAEhB,kBAAkB;EAClB,yBAAyB;EACzB,yDAAuuC;;EAEvuC,0BAA0B;EAC1B;;+BAE6B;;EAE7B,cAAc;EACd,kBAAkB;EAClB,kBAAkB;;EAElB,0BAA0B;EAC1B,4CAA4C;;EAE5C,aAAa;EACb,oBAAoB;;EAEpB,yCAAyC;EACzC,8CAA8C;AAChD;;AAEA,6BAA6B;AAC7B;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gGAAgG;EAChG,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;;EAEhB,sBAAsB;EACtB,qBAAqB,EAAE,gCAAgC;EACvD,gBAAgB;EAChB,kFAAkF,EAAE,gCAAgC;AACtH;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,eAAe;EACf,gGAAgG;EAChG,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB,EAAE,0BAA0B;EAC5C,aAAa;EACb,eAAe;EACf,gGAAgG;EAChG,WAAW;EACX,aAAa;EACb,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,MAAM,EAAE,OAAO,EAAE,QAAQ,EAAE,SAAS;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB,EAAE,qBAAqB;EAC3C,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;;EAEzB,sCAAsC;EACtC,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;;EAElB,kCAAkC,EAAE,wBAAwB;EAC5D,UAAU;EACV,wEAAwE;;EAExE,8CAA8C;EAC9C,0CAA0C;EAC1C,sCAAsC;;EAEtC,8DAA8D;AAChE;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,KAAK,kCAAkC,EAAE,YAAY,EAAE;AACzD;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,WAAW;EACX,gGAAgG;EAChG,sBAAsB;EACtB,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB,EAAE,0BAA0B;EAC9C,uBAAuB;AACzB;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;EACf,sCAAsC;AACxC;;;AAGA,+DAA+D;AAC/D;EACE,mBAAmB,EAAE,qBAAqB;EAC1C,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA,kEAAkE;AAClE;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,kCAAkC;AAClC;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,gCAAgC;AAChC;EACE,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,oCAAoC;AACpC;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,oBAAoB;AACpB;EACE,oCAAoC,EAAE,uDAAuD;EAC7F,0BAA0B,EAAE,qCAAqC;EACjE,kBAAkB;AACpB;;AAEA;EACE,0CAA0C,EAAE,8BAA8B;EAC1E,sCAAsC;AACxC;;AAEA,6BAA6B;;AAE7B,0CAA0C;AAC1C;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA,qBAAqB;AACrB;EACE,oCAAoC,EAAE,mCAAmC;EACzE,gCAAgC;EAChC,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,wCAAwC;AACxC;;EAEE,qCAAqC,EAAE,qBAAqB;EAC5D,cAAc,EAAE,uCAAuC;EACvD,gBAAgB;EAChB,kBAAkB;EAClB,gGAAgG,EAAE,uBAAuB;EACzH,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,oEAAoE;AACpE;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,0CAA0C;;AAE1C,gEAAgE;AAChE;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,0CAA0C;AAC5C;;AAEA,2DAA2D;AAC3D;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,6BAA6B,EAAE,uBAAuB;AACxD;;AAEA,2CAA2C;;AAE3C;EACE,uBAAuB;EACvB,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,gGAAgG;EAChG,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,gGAAgG;EAChG,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,mDAAmD;AACnD;EACE,kBAAkB;EAClB,MAAM,EAAE,OAAO,EAAE,QAAQ,EAAE,SAAS;EACpC,mBAAmB,EAAE,uDAAuD;EAC5E,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,OAAO,2BAA2B,EAAE;EACpC,KAAK,wBAAwB,EAAE;AACjC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,gCAAgC;EAChC,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,oCAAoC;EACpC,aAAa;EACb,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,2DAA2D;AAC3D;EACE,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB,EAAE,qCAAqC;EAC5D,kFAAkF;EAClF,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,qCAAqC;EACrC,gBAAgB;EAChB,eAAe;AACjB;;AAEA,aAAa,YAAY,EAAE,iBAAiB,EAAE;AAC9C,WAAW,iBAAiB,EAAE;AAC9B,eAAe,cAAc,EAAE;AAC/B,gBAAgB,cAAc,EAAE","sourcesContent":["/* Контейнер: Лист бумаги на столе */\n.quiz-container {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n\n  width: 90%;\n  max-width: 360px;\n\n  /* Эффект бумаги */\n  background-color: #f4e4bc;\n  background-image: url(\"data:image/svg+xml,%3Csvg width='100' height='100' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11 18c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm48 25c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm-43-7c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm63 31c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM34 90c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm56-76c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM12 86c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm28-65c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm23-11c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-6 60c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm29 22c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zM32 63c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm57-13c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-9-21c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM60 91c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM35 41c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM12 60c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2z' fill='%239C92AC' fill-opacity='0.08' fill-rule='evenodd'/%3E%3C/svg%3E\");\n\n  /* Тени для объема листа */\n  box-shadow:\n    1px 1px 0 rgba(0,0,0,0.1),\n    0 10px 30px rgba(0,0,0,0.5);\n\n  color: #2c2c2c;\n  padding: 25px 20px;\n  border-radius: 2px;\n\n  /* Эффект старого шрифта */\n  font-family: 'Times New Roman', Times, serif;\n\n  z-index: 6000;\n  pointer-events: auto;\n\n  /* Небольшой поворот для естественности */\n  transform: translate(-50%, -50%) rotate(-1deg);\n}\n\n/* Скрепка или штамп в углу */\n.quiz-header {\n  border-bottom: 2px solid #333;\n  margin-bottom: 20px;\n  padding-bottom: 10px;\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n}\n\n.quiz-title {\n  font-size: 20px;\n  font-weight: 900;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.quiz-progress {\n  font-size: 14px;\n  font-family: 'Apple Color Emoji', 'Segoe UI Emoji', 'Noto Color Emoji', 'Courier New', monospace;\n  font-weight: bold;\n}\n\n/* Текст вопроса */\n.quiz-question-text {\n  font-size: 18px;\n  line-height: 1.4;\n  margin-bottom: 25px;\n  min-height: 60px;\n  font-weight: 600;\n\n  /* --- ДОБАВЛЕНО --- */\n  white-space: pre-wrap; /* Сохраняет переносы строк \\n */\n  text-align: left;   \n  font-family: 'Apple Color Emoji', 'Segoe UI Emoji', 'Noto Color Emoji', sans-serif; /* Улучшает отображение эмодзи */\n}\n\n/* Варианты ответов */\n.quiz-options-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  width: 100%;\n}\n\n.quiz-btn {\n  background: transparent;\n  border: 2px solid #555;\n  color: #333;\n  padding: 12px;\n  font-size: 16px;\n  font-family: 'Apple Color Emoji', 'Segoe UI Emoji', 'Noto Color Emoji', 'Courier New', monospace;\n  font-weight: bold;\n  cursor: pointer;\n  text-align: left;\n  transition: all 0.1s ease;\n  position: relative;\n  overflow: hidden;\n}\n\n.quiz-btn:active {\n  background: #333;\n  color: #f4e4bc;\n  transform: scale(0.98);\n}\n\n/* Поле ввода */\n.quiz-input-row {\n  display: flex;\n  gap: 8px;\n}\n\n.quiz-input {\n  flex: 1;\n  background: transparent;\n  border: 2px solid #333;\n  border-radius: 0; /* Прямые углы для стиля */\n  padding: 10px;\n  font-size: 18px;\n  font-family: 'Apple Color Emoji', 'Segoe UI Emoji', 'Noto Color Emoji', 'Courier New', monospace;\n  color: #333;\n  outline: none;\n  min-width: 0;\n}\n\n.quiz-input:focus {\n  background: rgba(0,0,0,0.05);\n  border-color: #000;\n}\n\n.quiz-submit-btn {\n  background: #333;\n  color: #f4e4bc;\n  border: none;\n  padding: 0 20px;\n  font-weight: bold;\n  font-size: 20px;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n/* --- ШТАМПЫ РЕЗУЛЬТАТА --- */\n.quiz-stamp-overlay {\n  position: absolute;\n  top: 0; left: 0; right: 0; bottom: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  pointer-events: none; /* Пропускаем клики */\n  z-index: 10;\n}\n\n.stamp {\n  font-size: 32px;\n  font-weight: 900;\n  text-transform: uppercase;\n\n  /* Эффект двойной рамки как у печати */\n  border: 6px double;\n  padding: 10px 20px;\n  border-radius: 8px;\n\n  transform: rotate(-15deg) scale(2); /* Начинаем с большого */\n  opacity: 0;\n  animation: stampIn 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;\n\n  /* Добавим фон для четкого перекрытия текста */\n  background-color: rgba(255, 255, 255, 0.9);\n  box-shadow: 0 4px 10px rgba(0,0,0,0.2);\n\n  /* Убрана невалидная маска, которая делала элемент невидимым */\n}\n\n.stamp-success {\n  color: #27ae60;\n  border-color: #27ae60;\n  text-shadow: 0 0 0 #27ae60;\n}\n\n.stamp-fail {\n  color: #c0392b;\n  border-color: #c0392b;\n}\n\n@keyframes stampIn {\n  to { transform: rotate(-15deg) scale(1); opacity: 0.8; }\n}\n\n/* Финальный экран */\n.quiz-final {\n  text-align: center;\n}\n.final-score {\n  font-size: 48px;\n  font-weight: bold;\n  margin: 20px 0;\n  color: #333;\n  font-family: 'Apple Color Emoji', 'Segoe UI Emoji', 'Noto Color Emoji', 'Courier New', monospace;\n  border: 3px solid #333;\n  display: inline-block;\n  padding: 10px 20px;\n  border-radius: 50%; /* Круглая печать оценки */\n  transform: rotate(5deg);\n}\n\n/* Таймер */\n.quiz-timer {\n  position: absolute;\n  top: -40px;\n  right: 0;\n  background: #333;\n  color: #f4e4bc;\n  padding: 5px 10px;\n  border-radius: 4px;\n  font-family: monospace;\n  font-weight: bold;\n  font-size: 16px;\n  box-shadow: 0 5px 10px rgba(0,0,0,0.3);\n}\n\n\n/* Состояние: Ожидание ответа сервера (выбрано пользователем) */\n.quiz-btn.pending {\n  background: #dcd0b0; /* Чуть темнее фона */\n  border-color: #333;\n  color: #333;\n  cursor: wait;\n  transform: scale(0.98);\n}\n\n/* Состояние: Правильный ответ (подсветка при показе результата) */\n.quiz-btn.correct {\n  background: #d4edda;\n  border-color: #28a745;\n  color: #155724;\n}\n\n/* Состояние: Неправильный выбор */\n.quiz-btn.wrong {\n  background: #f8d7da;\n  border-color: #dc3545;\n  color: #721c24;\n}\n\n/* Блокировка остальных кнопок */\n.quiz-btn.disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  pointer-events: none;\n}\n\n/* Поле ввода - состояние загрузки */\n.quiz-input-row.pending {\n  opacity: 0.7;\n  pointer-events: none;\n}\n\n.quiz-input.pending {\n  background-color: #eec;\n}\n\n/* Улучшаем штампы */\n.quiz-stamp-overlay {\n  background: rgba(244, 228, 188, 0.4); /* Полупрозрачный фон, чтобы приглушить текст вопроса */\n  backdrop-filter: blur(1px); /* Легкий блюр для фокуса на штампе */\n  border-radius: 4px;\n}\n\n.stamp {\n  background-color: rgba(255, 255, 255, 0.8); /* Фон для читаемости штампа */\n  box-shadow: 0 4px 15px rgba(0,0,0,0.2);\n}\n\n/* --- СТИЛИ ДЛЯ ИНПУТА --- */\n\n/* Состояние: Ожидание (отправили, ждем) */\n.quiz-input.pending {\n  opacity: 0.7;\n  background-color: #eee;\n}\n\n/* Состояние: ВЕРНО */\n.quiz-input.correct {\n  background-color: #d4edda !important; /* !important перебивает disabled */\n  border-color: #28a745 !important;\n  color: #155724 !important;\n  opacity: 1 !important;\n}\n\n/* Состояние: ОШИБКА */\n.quiz-input.incorrect {\n  background-color: #f8d7da !important;\n  border-color: #dc3545 !important;\n  color: #721c24 !important;\n  opacity: 1 !important;\n}\n\n/* Стилизация тега code внутри вопроса */\n.quiz-question-text code,\n.quiz-btn code {\n  background-color: rgba(0, 0, 0, 0.08); /* Легкий серый фон */\n  color: #c7254e; /* Цвет текста (или оставьте inherit) */\n  padding: 2px 4px;\n  border-radius: 4px;\n  font-family: 'Apple Color Emoji', 'Segoe UI Emoji', 'Noto Color Emoji', 'Courier New', monospace; /* Моноширинный шрифт */\n  font-size: 0.95em;\n  font-weight: bold;\n}\n\n/* Опционально: убедитесь, что bold и italic наследуются правильно */\n.quiz-question-text b, .quiz-question-text strong {\n  font-weight: 800;\n}\n\n.quiz-question-text i, .quiz-question-text em {\n  font-style: italic;\n}\n\n/* --- Стили для результатов ответов --- */\n\n/* Класс для кнопки с правильным ответом (всегда подсвечиваем) */\n.quiz-btn.reveal-correct {\n  background-color: #d4edda;\n  border-color: #28a745;\n  color: #155724;\n  box-shadow: 0 0 8px rgba(40, 167, 69, 0.4);\n}\n\n/* Класс для кнопки, если пользователь выбрал НЕПРАВИЛЬНО */\n.quiz-btn.reveal-wrong {\n  background-color: #f8d7da;\n  border-color: #dc3545;\n  color: #721c24;\n  text-decoration: line-through; /* Зачеркиваем ошибку */\n}\n\n/* --- Кнопка и экран \"Анализ ошибок\" --- */\n\n.quiz-close-btn {\n  background: transparent;\n  border: 2px solid #555;\n  color: #333;\n  padding: 10px;\n  font-size: 18px;\n  font-weight: 800;\n  font-family: 'Apple Color Emoji', 'Segoe UI Emoji', 'Noto Color Emoji', 'Courier New', monospace;\n  cursor: pointer;\n  text-align: center;\n  text-transform: uppercase;\n  transition: all 0.1s ease;\n  position: relative;\n  overflow: hidden;\n}\n\n.quiz-history-btn {\n  background: #34495e;\n  color: #f4e4bc;\n  border: 2px solid #2c3e50;\n  width: 100%;\n  padding: 10px;\n  font-size: 18px;\n  font-weight: 800;\n  font-family: 'Apple Color Emoji', 'Segoe UI Emoji', 'Noto Color Emoji', 'Courier New', monospace;\n  cursor: pointer;\n  text-align: center;\n  margin-top: 10px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  transition: all 0.2s;\n}\n\n.quiz-history-btn:active {\n  transform: scale(0.98);\n}\n\n/* Оверлей истории (стилизован под папку с делом) */\n.quiz-history-overlay {\n  position: absolute;\n  top: 0; left: 0; right: 0; bottom: 0;\n  background: #f4e4bc; /* Тот же цвет \"бумаги\", что и у основного контейнера */\n  z-index: 20;\n  display: flex;\n  flex-direction: column;\n  padding: 20px 15px;\n  animation: slideUp 0.3s ease-out;\n  border-radius: 2px;\n}\n\n@keyframes slideUp {\n  from { transform: translateY(100%); }\n  to { transform: translateY(0); }\n}\n\n.history-header-title {\n  font-size: 20px;\n  font-weight: 900;\n  text-align: center;\n  color: #2c3e50;\n  border-bottom: 2px solid #2c3e50;\n  padding-bottom: 10px;\n  margin-bottom: 15px;\n  text-transform: uppercase;\n}\n\n.history-list {\n  flex: 1;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding-right: 5px;\n}\n\n.history-list * {\n  touch-action: pan-y;\n}\n\n/* Элемент истории (вопрос) */\n.history-item {\n  background: rgba(255, 255, 255, 0.6);\n  padding: 10px;\n  border-radius: 6px;\n  border-left: 5px solid #ccc;\n  text-align: left;\n}\n\n.history-item.correct {\n  border-left-color: #27ae60;\n}\n\n.history-item.wrong {\n  border-left-color: #c0392b;\n}\n\n/* Текст вопроса в истории (с переносами строк для сетки) */\n.history-q-text {\n  font-weight: 600;\n  margin-bottom: 8px;\n  white-space: pre-wrap; /* ВАЖНО: сохраняет структуру сетки */\n  font-family: 'Apple Color Emoji', 'Segoe UI Emoji', 'Noto Color Emoji', sans-serif;\n  font-size: 14px;\n  line-height: 1.3;\n  color: #333;\n}\n\n.history-answer-row {\n  display: flex;\n  justify-content: space-between;\n  font-size: 13px;\n  border-top: 1px solid rgba(0,0,0,0.1);\n  padding-top: 5px;\n  margin-top: 5px;\n}\n\n.ans-label { opacity: 0.7; margin-right: 4px; }\n.ans-val { font-weight: bold; }\n.ans-val.bad { color: #c0392b; }\n.ans-val.good { color: #27ae60; }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
